module.exports = __webpack_public_path__ + "media/components/sessions/email-verification/img/verification-complete-547af679c205690818eb73f043313250.svg";